<template>
	<div class="container-fluid mt-4">
		<div class="row justify-content-center">
			<div class="col-md-10">
				<div class="card shadow-sm">
					<div class="card-header d-flex justify-content-between align-items-center">
						<h5 class="mb-0 text-muted">UPLOADED</h5>
						<div>
							<button class="btn btn-link text-info fw-bold" @click="openNewApkModal">
								<i class="fa fa-plus me-1"></i>UPLOAD
							</button>
							<span v-if="isLoading.apkUpload" class="badge bg-warning text-dark ms-2">
								LOADING <i class="fas fa-spinner fa-spin ms-1"></i>
							</span>
						</div>
					</div>
					<div class="card-body p-0">
						<div class="table-responsive">
							<el-table :data="apkList" v-if="apkList.length" style="width: 100%; min-width: 800px" border>
								<el-table-column size="small" prop="appName" label="App Name" />
								<el-table-column prop="type" label="Type" />
								<el-table-column prop="latestVersion" label="Version" />
								<el-table-column prop="deviceType" label="Device Type" />
								<el-table-column prop="description" label="Description" />
								<el-table-column prop="status" label="Status" />
								<el-table-column label="Actions">
									<template #default="scope">
										<el-button :class="scope.row.id <= 7 ? 'aml-bg-orange-2' : '' " size="small" @click="openEditApkModal(scope.row)">
											<i class="fas fa-pen" /> Edit
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>

				</div>
			</div>
		</div>

		<!-- APK Modal -->
		<el-dialog v-if="showApkModal" v-model="showApkModal" @close="handleCancel"
			:title="apkForm.id ? 'Edit APK' : 'Upload APK'" width="600px" append-to-body>
			<el-form :model="apkForm" :rules="rules" ref="apkFormRef" label-width="140px">
				<el-form-item label="App Name" prop="appName">
					<el-input v-model="apkForm.appName" />
				</el-form-item>
				<el-form-item label="Type" prop="type" v-if="!apkForm.id || apkForm.id > 7">
					<el-select v-model="apkForm.type" class="w-100">
						<el-option label="Event" value="event" />
						<el-option label="Test" value="test" />
						<el-option label="Staging" value="staging" />
					</el-select>
				</el-form-item>

				<el-form-item label="Min Version" prop="minVersion" v-if="apkForm.id && apkForm.id <= 7">
					<el-input v-model="apkForm.minVersion" />
				</el-form-item>

				<el-form-item label="Max Version" prop="maxVersion" v-if="apkForm.id && apkForm.id <= 7">
					<el-input v-model="apkForm.maxVersion" />
				</el-form-item>

				<el-form-item label="Version" prop="latestVersion">
					<el-input v-model="apkForm.latestVersion" />
				</el-form-item>

				<el-form-item label="Device Type" prop="deviceType" v-if="!apkForm.id || apkForm.id > 7">

					<el-select v-model="apkForm.deviceType" class="w-100">
						<el-option v-for="type in defaultDeviceTypes"
								   :key="type.model" :label="type.name.toUpperCase()" :value="type.model"/>
					</el-select>
				</el-form-item>

				<el-form-item label="Description" v-if="!apkForm.id || apkForm.id > 7">
					<el-select v-model="apkForm.description" class="w-100" allow-create filterable>
						<el-option v-for="type in defaultDescription"
								   :key="type" :label="type.toUpperCase()" :value="type.toUpperCase()"/>
					</el-select>
				</el-form-item>

				<el-form-item label="Status" prop="status" v-if="!apkForm.id || apkForm.id > 7">
					<el-select v-model="apkForm.status" class="w-100">
						<el-option label="Active" value="active" />
						<el-option label="Inactive" value="inactive" />
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="APK File">
					<el-upload :http-request="handleFileUpload" :show-file-list="false" accept=".apk">
						<el-button>Choose APK</el-button>
					</el-upload>
					<span v-if="uploadedApkPath" className="text-success small ms-2">✔ Uploaded</span>
				</el-form-item> -->

				<!-- <el-form-item label="APK File">
					<el-upload :show-file-list="false" :before-upload="handleFileUpload" accept=".apk">
						<el-button :loading="isUploading">{{ isUploading ? "Uploading..." : "Choose APK" }}</el-button>
					</el-upload>
					<span v-if="uploadedApkPath && !isUploading" class="text-success small ms-2">✔ Uploaded</span>
				</el-form-item> -->
				<el-form-item label="APK File">
					<el-upload :show-file-list="false" :before-upload="handleFileSelect" accept=".apk">
						<el-button :loading="isUploading">{{ isUploading ? "Uploading..." : "Choose APK" }}</el-button>
					</el-upload>
					<span v-if="selectedFile && !isUploading" class="text-success small ms-2">✔ File Selected</span>

				</el-form-item>
				<el-form-item label=" " label-width="140px">
					<el-button size="small" type="primary" plain @click="sendOtp">Send OTP</el-button>
				</el-form-item>
				<el-form-item label="OTP" v-if="otpSent">
					<div class="d-flex gap-2">
						<!-- <input v-for="(val, index) in otp" :key="index" v-model="otp[index]"
							:ref="el => otpInputs[index] = el" @keydown.backspace="handleBackspace(index, $event)"
							@input="focusNext(index, $event)" @paste="handlePaste($event)" maxlength="1"
							class="form-control text-center otp-box" /> -->
						<input v-for="(val, index) in otp" :key="index" v-model="otp[index]" :ref="setOtpRef"
							@input="focusNext(index, $event)" @keydown.backspace="handleBackspace(index, $event)"
							@paste="handlePaste($event)" maxlength="1" class="form-control text-center otp-box" />

					</div>
				</el-form-item>



				<!-- <el-form-item label="OTP" v-if="otpSent">
					<el-input v-model="otpCode" />
				</el-form-item> -->
			</el-form>

			<template #footer>
				<el-button @click="handleCancel">Cancel</el-button>
				<el-button type="primary" @click="submitApkForm" :loading="isUploading"
					:disabled="getOtpCode().length < 4">
					Submit
				</el-button>
			</template>

		</el-dialog>
	</div>
</template>

<script>
import axios from 'axios';
import { ElMessage, ElSelect } from "element-plus";
import { Notification } from "@/components";
import { useToast } from "vue-toastification";

export default {
	components: { ElSelect },
	inject: ['$baseURL', '$numFrm', '$formatDateTime', '$isCheckEventType'],
	emits: [ 'event-fetched', 'loading-complete' ],
	data() {
		return {
			defaultInfo: {
				event: { name: '', country: 'india', type: '' },
				dashSettings: {
					addActivationTopup: 1,
					addCouponTopup: 1,
					addCompTopup: 1,
					autoDayClose: 0,
				},
				components: { blocked: false, },
				isLoading: { blocked: true, event: true, },
			},
			loginUser: {},
			event: { name: '', country: 'india', type: '' },
			isLoading: { apkUpload: true, event: true, },
			apkList: [],
			// isLoading: false,
			isUploading: false,
			showApkModal: false,
			selectedFile: null,
			otpCode: '',
			otpSent: false,
			otp: ["", "", "", ""],
			otpInputs: [],
			uploadedApkPath: '',
			defaultDescription: [ 'TURNSTILE', 'ACCESSX', 'CASHLESS', 'ISSUANCE' ],
			defaultDeviceTypes: [
				{ name: 'Wisepos+', model: 'wisepos+' },
				{ name: 'Famoco / Inbuilt', model: 'Famoco' },
				{ name: 'GateX Turnstile Reader', model: 'serialNFC' },
				{ name: 'Cashlez Sunmipay', model: 'sunmipay' },
				{ name: 'Mosambee MF919', model: 'MF919' },
				{ name: 'Mosambee | DX8000', model: 'DX8000' },
				{ name: 'Ezetap', model: 'ezetap' },
				{ name: 'Worldline', model: 'worldline' },
				{ name: 'Airpay', model: 'airpay' },
				{ name: 'PinelabsPax', model: 'pinelabsPax' },
				{ name: 'Sunmi', model: 'Sunmi' },
				{ name: 'utapSunmi', model: 'utapSunmi' },
				{ name: 'Other', model: 'other' },
			],
			components: { apkUpload: false, },
			apkForm: {
				id: null,
				appName: '',
				minVersion: '',
				maxVersion: '',
				latestVersion: '',
				deviceType: 'other',
				status: 'active',
				type: 'event',
			},
			rules: {
				appName: [{ required: true, message: 'App name is required', trigger: 'blur' }],
				type: [{ required: true, message: 'Type is required', trigger: 'change' }],
				// minVersion: [{ required: true, message: 'Minimum version is required', trigger: 'blur' }],
				// maxVersion: [{ required: true, message: 'Maximum version is required', trigger: 'blur' }],
				latestVersion: [{ required: true, message: 'Latest version is required', trigger: 'blur' }],
				deviceType: [{ required: true, message: 'Device type is required', trigger: 'change' }],
				status: [{ required: true, message: 'Status is required', trigger: 'change' }],
			},
		};
	},
	// mounted() {
	// 	this.fetchApks();
	// },
	mounted() {
		// setTimeout(this.loadDetails, 500);
		let u = JSON.parse(localStorage.getItem('user'));
		this.loginUser = u;
		if (!u || Object.keys(u).length === 0 && u.constructor === Object) return this.$router.push('/login');
		this.loadDetails();
	},
	watch: {
		$route(to, from) {
			let u = JSON.parse(localStorage.getItem('user'));
			this.loginUser = u;
			if (!u || Object.keys(u).length === 0 && u.constructor === Object) return this.$router.push('/login');
			this.loadDetails();
		},
	},
	methods: {
		runToast(text, pos, type, ownText, ownIcon) {
			// const text =
			// 	"Welcome to <b>Vue Now UI Dashboard Pro</b> - a beautiful premium dashboard for every web developer";
			const icon = "now-ui-icons ui-1_bell-53";
			const content = {
				component: Notification,

				props: {
					ownText: ownText,
					ownIcon: ownIcon,
					icon: icon,
					text: text,
					type: type,
				},
			};
			const toast = useToast();
			toast(content, {
				hideProgressBar: true,
				icon: false,
				closeButton: false,
				position: pos,
			});
		},
		setDefault(key = 'all') {
			if(key !== 'all')  this[key] = JSON.parse(JSON.stringify(this.defaultInfo[key]));
			else {
				for (const [key, value] of Object.entries(this.defaultInfo)) {
					this[key] = JSON.parse(JSON.stringify(value));
				}
			}
		},
		loadDetails() {
			let u = this.loginUser;
			let code = 0;
			let url = '';
			switch (u.loginType) {
				case 'event':
					url = '/Event/Details/';
					code = u.id;
					break;
				case 'admin':
					url = '/Event/Details/';
					code = this.$route.params.code;
					break;
				case 'operator':
					url = '/Users/Details/';
					code = u.id;
					break;
				default:
					return ;
					break;
			}
			axios.get(
				this.$baseURL + '/Event/Details/',
				{ params: { code }, headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
			)
				.then(response => {
					this.setDefault('event');
					this.event = response.data.event;
					if(response.data.dashSettings) this.dashSettings = response.data.dashSettings;
					// console.log('dashSettings', this.dashSettings);
					this.isLoading.event = false;
					// this.dataLoad();
					this.$emit('event-fetched', this.event);
					this.setComponentsDisplay();
					this.$emit('loading-complete');
					this.fetchApks();
				})
				.catch( (error) => {
					this.runToast('', 'top-right', 'danger', "<b>Something went wrong</b><br>Please try again.", "fas fa-bomb fa-4x");
					console.log("err:", error);
				});
		},
		setComponentsDisplay () {
			this.setDefault('components');

			switch(this.event.type) {
				case 'fnb':
				case 'event':
					this.components.apkUpload = true;
					break;
			}
		},
		handleCancel() {
			this.showApkModal = false;
			this.isUploading = false;
			this.selectedFile = null;
			this.otpInputs = [];
		}
		,
		handleFileSelect(file) {
			this.selectedFile = file;
			return false; // Prevent auto-upload
		},
		setOtpRef(el) {
			if (el) {
				if (!this.otpInputs.includes(el)) this.otpInputs.push(el);
			}
		},

		focusNext(index, e) {
			if (e.inputType === 'deleteContentBackward') return;
			if (this.otp[index].length === 1 && index < this.otpInputs.length - 1) {
				this.otpInputs[index + 1].focus();
			}
		},

		handleBackspace(index, e) {
			if (this.otp[index] === "" && index > 0) {
				this.otpInputs[index - 1].focus();
				this.otp[index - 1] = "";
			}
		},
		handlePaste(e) {
			e.preventDefault();
			const paste = e.clipboardData.getData('text').trim().slice(0, 4).split('');
			this.otp = [...paste, '', '', '', ''].slice(0, 4);

			this.$nextTick(() => {
				for (let i = 0; i < this.otp.length; i++) {
					if (!this.otp[i] && this.otpInputs[i]) {
						this.otpInputs[i].focus();
						break;
					}
				}
			});
		}


		,
		getOtpCode() {
			return this.otp.join('');
		},
		async fetchApks() {
			this.isLoading.apkUpload = true;

			let u = this.loginUser;
			let code = 0;
			let url = '';
			switch (u.loginType) {
				case 'event':
					url = '/Event/Details/';
					code = u.id;
					break;
				case 'admin':
					url = '/Event/Details/';
					code = this.$route.params.code;
					break;
				case 'operator':
					url = '/Users/Details/';
					code = u.id;
					break;
				default:
					return ;
					break;
			}

			try {
				const res = await axios.get(
					this.$baseURL + '/apk/EventWise/List/',
					{ params: { eventId: code }, headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
				)
				// console.log("APK LIST RESPONSE:", res);

				if (res?.data?.success) {
					this.apkList = res.data.apps || [];
				} else {
					console.warn("Unexpected response format or success=false", res.data);
					this.apkList = []; // fallback
				}
			} catch (err) {
				console.error('Error loading APKs:', err);
				ElMessage.error("Failed to load APKs.");
			} finally {
				this.isLoading.apkUpload = false;
				console.log("isLoading set to false");
			}
		}
		,
		openNewApkModal() {
			this.otpInputs = [];
			this.isUploading = false;
			this.apkForm = {
				id: null,
				appName: '',
				minVersion: '',
				maxVersion: '',
				latestVersion: '',
				deviceType: 'other',
				status: 'active',
			};
			this.uploadedApkPath = '';
			this.otpCode = '';
			this.otpSent = false;
			this.showApkModal = true;
			this.$nextTick(() => this.$refs.apkFormRef?.clearValidate());
		},
		openEditApkModal(apk) {
			this.otpInputs = [];
			this.otp = ["", "", "", ""];
			this.isUploading = false;
			this.apkForm = {
				...apk,
				// minVersion: apk.latestVersion,
				// maxVersion: apk.latestVersion,
			};
			if(apk.id && apk.id > 7) {
				this.apkForm.minVersion = apk.latestVersion;
				this.apkForm.maxVersion = apk.latestVersion;
			}
			this.uploadedApkPath = apk.atomxStore || '';
			this.otpCode = '';
			this.otpSent = false;
			this.showApkModal = true;
			this.$nextTick(() => this.$refs.apkFormRef?.clearValidate());
		},
		async sendOtp() {
			this.isLoading.apkUpload = true;

			let u = this.loginUser;
			let code = 0;
			let url = '';
			switch (u.loginType) {
				case 'event':
					url = '/Event/Details/';
					code = u.id;
					break;
				case 'admin':
					url = '/Event/Details/';
					code = this.$route.params.code;
					break;
				case 'operator':
					url = '/Users/Details/';
					code = u.id;
					break;
				default:
					return ;
					break;
			}

			const res = await axios.get(
				this.$baseURL + '/apk/SendOTP/',
				{ params: { eventId: code }, headers: { Authorization: `Bearer ${localStorage.getItem('xToken')}` }}
			)
			this.isLoading.apkUpload = false;
			if (res.data.success) {
				this.otpSent = true;
				this.otpCode = '';
				ElMessage.success('OTP sent');
			}
		},
		async submitApkForm() {
			this.$refs.apkFormRef.validate(async (valid) => {
				if (!valid) return;
				if (!this.otpSent) return ElMessage.warning('Please click "Send OTP" first');
				if (!this.selectedFile) return ElMessage.warning('Please choose an APK file');

				const otpCode = this.getOtpCode();
				if (otpCode.length < 4) return ElMessage.warning('Enter complete OTP');

				this.isUploading = true;

				let u = this.loginUser;
				let code = 0;
				let url = '';
				switch (u.loginType) {
					case 'event':
						url = '/Event/Details/';
						code = u.id;
						break;
					case 'admin':
						url = '/Event/Details/';
						code = this.$route.params.code;
						break;
					case 'operator':
						url = '/Users/Details/';
						code = u.id;
						break;
					default:
						return ;
						break;
				}

				try {
					// Step 1: Upload the file
					// const eventId = this.event.id;
					const filename = this.selectedFile.name.replace('.apk', '');
					const payload = {
						filename,
						fileType: 'apk',
						eventId: code,
						ContentType: 'application/vnd.android.package-archive',
						profileFileExt: 'apk',
					};

					const response = await axios.post('https://fnbxapi.atomx.in/fnbx/upload/getUploadUrl', payload);
					if (!response.data.success || !response.data.uploadUrl || !response.data.Key) {
						throw new Error("Failed to get upload URL.");
					}

					const { uploadUrl, Key } = response.data;
					const actualFile = this.selectedFile.raw || this.selectedFile;
					const blob = new Blob([actualFile], {
						type: "application/vnd.android.package-archive",
					});

					await axios.put(uploadUrl, blob);
					this.uploadedApkPath = `https://dashboard-atomx.s3.us-west-2.amazonaws.com/${Key}`;
					// this.uploadedApkPath = "https://dashboard-atomx.s3.us-west-2.amazonaws.com/apk/1647_Fnbx571_racecourse_____1759534614714.apk"

					// debugger;
					// Step 2: Save APK metadata
					const savePayload = {
						...this.apkForm,
						eventId: code,
						appLink: this.uploadedApkPath,
						otp: otpCode,
						// atomxStore: this.uploadedApkPath,
						// minVersion: this.apkForm.latestVersion,
						// maxVersion: this.apkForm.latestVersion,
					};
					// if(this.apkForm.id && this.apkForm.id > 7) {
					// 	savePayload.minVersion = this.apkForm.latestVersion;
					// 	savePayload.maxVersion = this.apkForm.latestVersion;
					// } else
					if(this.apkForm.id && this.apkForm.id <= 7) {
						savePayload.minVersion = this.apkForm.minVersion;
						savePayload.maxVersion = this.apkForm.maxVersion;
					} else {
						savePayload.minVersion = this.apkForm.latestVersion;
						savePayload.maxVersion = this.apkForm.latestVersion;
					}
					if (!this.apkForm.id) delete savePayload.id;
					if( this.apkForm.id && this.apkForm.id <= 7 )	delete savePayload.eventId;
					// debugger;

					// const saveRes = await axios.post('https://dashapi.atomx.in/dashboardAPI/v1/apk/EventWise/Save', savePayload);
					const saveRes = await axios.post(this.$baseURL + '/apk/EventWise/Save/', savePayload )
					// console.log(saveRes.data.success)

					if (!saveRes.data.success || saveRes.data.success == "undefined") {
						throw new Error(saveRes.data.message || 'Save failed. Please try again.');
					}

					ElMessage.success('APK saved');
					this.showApkModal = false;
					this.fetchApks();
				} catch (err) {
					console.error("Error in submit:", err);
					ElMessage.error(err?.response?.data?.message || err.message || "An unexpected error occurred.");
				} finally {
					this.isUploading = false;
				}
			});
		}
	},
};
</script>

<style scoped>
.text-success {
	color: green;
}

.otp-box {
	width: 40px;
	height: 40px;
	font-size: 1.2rem;
	text-align: center;
	border: 1px solid #ccc;
	border-radius: 4px;
	outline: none;
}

@media (max-width: 768px) {
	.el-table .cell {
		font-size: 13px;
	}

	.el-dialog {
		width: 95% !important;
	}
}



.small {
	font-size: 0.875rem;
}
</style>
